<template>
  <div class="dados-privados-form">
    <modal-data-form
      :show-modal="store.showModalDataForm"
      :title="title"
      :on-save="onSave"
    >
      <field-group-form
        v-for="(item, i) in Object.keys(fields)"
        :group-label="$t(item)"
        :key="item + '_' + i"
      >
        <v-row>
          <v-col
            v-for="(subitem, i) in fields[item]"
            :key="'sub_' + item + '_' + i"
            class="ma-0 py-0 pt-2 pb-3"
            cols="12"
            md="5"
          >
            <v-chip
              v-if="subitem.value"
              color="transparent"
              text-color="deep-orange lighten-2"
              style="height: auto"
            >
              <v-switch
                v-model="subitem.value"
                :ripple="false"
                inset
                class="ma-0 pa-0 pt-2 text-wrap"
                dense
                color="deep-orange lighten-2"
              >
                <template #label>
                  <v-layout column>
                    <v-layout align-center>
                      <v-icon class="mr-1 deep-orange--text text--lighten-2"
                        >mdi-lock</v-icon
                      >
                      <small class="deep-orange--text text--lighten-2">{{
                        $t("restrito")
                      }}</small>
                    </v-layout>
                    <v-layout
                      style="margin-left: 2px"
                      class="deep-orange--text text--lighten-2"
                    >
                      {{ subitem.label }}
                    </v-layout>
                  </v-layout>
                </template>
              </v-switch>
            </v-chip>
            <v-chip
              v-else
              color="transparent"
              text-color="blue lighten-0"
              style="height: auto"
            >
              <v-switch
                v-model="subitem.value"
                :ripple="false"
                inset
                class="ma-0 pa-0 pt-2 text-wrap"
                dense
                color="blue lighten-0"
              >
                <template #label>
                  <v-layout column>
                    <v-layout align-center>
                      <v-icon class="mr-1 blue--text text--lighten-0"
                        >mdi-earth</v-icon
                      >
                      <small class="blue--text text--lighten-0">{{
                        $t("publico")
                      }}</small>
                    </v-layout>
                    <v-layout
                      style="margin-left: 2px"
                      class="blue--text text--lighten-0"
                    >
                      {{ subitem.label }}
                    </v-layout>
                  </v-layout>
                </template>
              </v-switch>
            </v-chip>
          </v-col>
        </v-row>
      </field-group-form>
    </modal-data-form>
  </div>
</template>

<script>
import ModalDataForm from "@/components/forms/modal-data-form";
import FieldGroupForm from "@/components/forms/field-group-form";
import { updateData } from "@/services";
export default {
  props: {
    title: {
      type: String,
    },
    selected: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { FieldGroupForm, ModalDataForm },
  data: () => ({
    fields: {},
    dataFileds: {},
  }),
  watch: {
    "store.showModalDataForm"() {
      this.fields = JSON.parse(JSON.stringify(this.selected));
      this.dataFields = JSON.parse(JSON.stringify(this.data));
    },
  },
  computed: {
    store() {
      return this.$store.state;
    },
    pessoa() {
      return this.$store.state.pessoa.data || {};
    },
  },
  beforeMount() {
    this.$store.commit("setShowModalDataForm", false);
  },
  methods: {
    onSave() {
      const fields = { ...this.dataFields, ...this.fields };
      const restricteds = Object.keys(fields)
        .map((key) => fields[key].filter((e) => e.value).map((e) => e.key))
        .filter((e) => e.length > 0);
      this.pessoa.camposRestritos = restricteds.join(",");
      updateData(this, "pessoa", this.pessoa);
    },
  },
};
</script>

<style scoped></style>
